module.exports = __webpack_public_path__ + "img/title-championship.6821aa20.png";